import { NewTaskType } from './../NewTask/newTask-reducer';
import {TaskStateType, UpdatedTasksResponse } from './../../api/projects-api';
import { logoutTC } from './../Login/auth-reducer';
import { CommentsPartType, fetchCommentsTC_ } from '../Task/Comments/comments-reducer';
import { projectsAPINEW, WorkItemType } from '../../api/projects-api';
import { setAppErrorAC, setAppStatusAC } from '../../app/app-reducer';
import { AppRootState } from '../../app/store';
import { handleRequestResponseError, handleServerNetworkError } from '../../utils/errorUtils/handleServerNetworkError';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {setCommentsState} from '../Task/Comments/comments-reducer'
import { setUpdatedTasks } from '../Notification/notification-reducer';

const initialState: InitialWorkItemsStateType = {
  workItemsState: {} as WorkItemsStateType,
  openedTabList: 'all',
  openedTab: 'details',
  isNewTask: false,
  newTaskID: 1,
  currentAttachmentUrl: '',
  currentAttachmentType: '',
  currentlyOpenedTask: {
    id: 1,
    title: '',
    priority: 2,
    status: '',
    systemInfo: ''
  }
}
export type WorkItemsStateType = {
  [key: string]: Array<WorkItemType>
}
export type SearchedArray = Array<number>
export type InitialWorkItemsStateType = {
  workItemsState: WorkItemsStateType
  openedTabList: string
  openedTab: string
  isNewTask: boolean
  newTaskID: number
  currentAttachmentUrl: string
  currentAttachmentType: string
  currentlyOpenedTask: NewTaskType
}

export const fetchWorkItemDataTC = createAsyncThunk('workItems/fetchItemData', async (params: { projectName: string, projectId: number, itemId: number, token: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  try {
    const res = await projectsAPINEW.fetchItemData(params.token, params.projectId, params.itemId)
    console.log('ITEM response', res.data.fields["Microsoft.VSTS.TCM.SystemInfo"])
    let currentTask = { id: res.data.id, title: res.data.fields["System.Title"], priority: res.data.fields["Microsoft.VSTS.Common.Priority"], status: res.data.fields["System.State"], systemInfo: res.data.fields["Microsoft.VSTS.TCM.SystemInfo"] }
    thunkAPI.dispatch(setWorkItemData({ item: res.data, projectName: params.projectName }))
    thunkAPI.dispatch(setCurrentlyOpendTask({ task: currentTask }))
    thunkAPI.dispatch(fetchCommentsTC_({ projectName: params.projectName, projectId: params.projectId, taskId: params.itemId }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
})

export const addPictureToNewSystemInfoTC = createAsyncThunk('addPictureToSystemInfo/newTask', async (params: {
  imgSrc: string, projectId: number, projectName: string, fileName: string,formData: any}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await projectsAPINEW.createAttachment(token, params.projectId, params.projectName, params.fileName, params.formData)
    //const id = res.data[0].id
    const state = thunkAPI.getState() as AppRootState
    let text = state.workItems.currentlyOpenedTask.systemInfo
    let newText = text + `<img alt=${params.fileName} src=${params.imgSrc} data-src=${res.data[0].url} />`
    thunkAPI.dispatch(setCurrentlyOpendTaskSystemInfo({ systemInfo: newText }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

export const updateTaskTC = createAsyncThunk('workItems/updateTask', async (params: {projectName: string, projectId: number, taskId: number}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    let description = state.workItems.currentlyOpenedTask.systemInfo
    if(!description) {
      description=''
    }
    let parser = new DOMParser()
    let html = parser.parseFromString(description, 'text/html')
    let arr = html.getElementsByTagName("img")
    for(let i=0; i< arr.length; i++){
      let serverSrc= arr[i].dataset.src
      if(serverSrc)
      arr[i].src = serverSrc
      arr[i].removeAttribute('data-src')
    }
    let newDescription =  new XMLSerializer().serializeToString(html)
    let taskState = state.workItems.currentlyOpenedTask.status
    const res = await projectsAPINEW.updateTask(token, params.projectId, params.taskId, taskState, newDescription)
    console.log('Update State by Task ', res.data)
    thunkAPI.dispatch(setWorkItemData({ item: res.data, projectName: params.projectName }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({ error: `Bug #${params.taskId} was updated!`, color: 'success' }))
  } catch(error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
 })

export const fetchSortedWorkItems = createAsyncThunk('workItem/sortWorkItems', async (params: { projectName: string, projectId: number,
   sort: string, sortMode: string, query: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await projectsAPINEW.fetchWorkItems(token, params.projectId, params.sort, params.sortMode, params.query)
    console.log('TASKS: ', res.data)
    let tasksRes = res.data.workitems as Array<WorkItemType>
    const updatedTasks = res.data.updatedWorkitems as Array<UpdatedTasksResponse>
    thunkAPI.dispatch(setUpdatedTasks(res.data.updatedWorkitems.length))
   updatedTasks.forEach( t=> {
    let task = tasksRes.find(tr => tr.id === t.workItemId)
    if(task){
      task.isUpdated = true
    }
   })
    thunkAPI.dispatch(setWorkItems({projectName: params.projectName, workItems: tasksRes}))
    let tasks = res.data.workitems.map((t: any) => {
      let task = {} as CommentsPartType
      task.taskId = t.id
      return task
    })
    thunkAPI.dispatch(setCommentsState({projectName: params.projectName, tasks: tasks}))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
}) 

export const openFileAC = createAsyncThunk('workItem/getFile', async (params: { projectId: number, url: string, fileName: string, filePath: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))

  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token

  let arr = params.url.split('/')
  const attachmentId = arr[arr.length - 1]
  let arr2 = params.fileName.split('.')
  const type = arr2[arr2.length - 1]

  try {
    const res = await projectsAPINEW.getAttachment(token, params.projectId, attachmentId, params.fileName)
    console.log("open file: ", res)
    const url = window.URL.createObjectURL(res.data)
    thunkAPI.dispatch(setCurrentAttachment({ url, type }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
}) 

export const addFileTC = createAsyncThunk('workItem/addAttachment', async (params: {projectName: string, projectId: number, fileName: string, formData: any, taskId: number}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))

  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token

  try {
    const res = await projectsAPINEW.createAttachment(token, params.projectId, params.projectName, params.fileName, params.formData)
    console.log('RES.DATA:               ', res.data[0].url)
    let url = res.data[0].url
    const res2 = await projectsAPINEW.addAttachment(token, params.projectId, params.taskId, url)
    thunkAPI.dispatch(setWorkItemData({item: res2.data, projectName: params.projectName}))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

export const removeAttachmentTC = createAsyncThunk('workItem/removeAttachment', async (params: {projectName: string, projectId: number, taskId: number, url: string}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  const tasks = state.workItems.workItemsState[params.projectName]
  const task = tasks.find(t => t.id === params.taskId)
  const index = task?.relations.findIndex(rel => rel.url === params.url)
  if(index === undefined){
    return
  }
  try {
    const res = await projectsAPINEW.removeAttachment(token, params.projectId, params.taskId, index)
   console.log('RES removeAttachment', res)
   thunkAPI.dispatch(setWorkItemData({item: res.data, projectName: params.projectName}))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

const slice = createSlice({
  name: 'workItems',
  initialState: initialState,
  reducers: {
    setIsNewTask(state, action: PayloadAction<{isNewTask: boolean}>) {
      state.isNewTask = action.payload.isNewTask
    },
    setNewTaskID(state, action: PayloadAction<{ id: number }>) {
      state.newTaskID = action.payload.id
    },
    setWorkItemData(state, action: PayloadAction<{item: WorkItemType, projectName: string}>) {
     const workItems = state.workItemsState[action.payload.projectName]
     const index = workItems.findIndex(i => i.id === action.payload.item.id)
     workItems[index] = action.payload.item
    },
    setWorkItems(state, action: PayloadAction<{projectName: string, workItems: Array<WorkItemType>}>) {
      if(action.payload) {
            state.workItemsState[action.payload.projectName] = action.payload.workItems
         }
    },
    setUpdatedWorkItems(state, action: PayloadAction<{projectName: string}>) {
      if(action.payload) {
        let tasks = state.workItemsState[action.payload.projectName]
        let updTasks = tasks.filter(t => t.isUpdated === true)
        state.workItemsState[action.payload.projectName] = updTasks
     }
    },
    setTab(state, action: PayloadAction<{tabName: string}>) {
      if(action.payload) {
        state.openedTab = action.payload.tabName
     }
    },
    setTabList(state, action: PayloadAction<{tabName: string}>) {
      if(action.payload) {
        state.openedTabList = action.payload.tabName
     }
    },
    setCurrentAttachment(state, action: PayloadAction<{url: string, type: string}>) {
      if(action.payload) {
        state.currentAttachmentUrl = action.payload.url
        state.currentAttachmentType = action.payload.type
     }
     },
     downloadAttachment(state ){
       const url = state.currentAttachmentUrl
       const linkUrl = document.createElement('a')
       //const url = window.URL.createObjectURL(res.data)
       linkUrl.download = url
       linkUrl.href = url
       document.body.appendChild(linkUrl)
       linkUrl.click()
       document.body.removeChild(linkUrl)
       linkUrl.remove()
     },
     setCurrentlyOpendTask(state, action: PayloadAction<{task: NewTaskType}>){
      state.currentlyOpenedTask = action.payload.task
     },
     setCurrentlyOpendTaskSystemInfo(state, action: PayloadAction<{systemInfo: string}>){
      state.currentlyOpenedTask.systemInfo = action.payload.systemInfo
     },
     setCurrentlyOpenedTaskState(state, action: PayloadAction<{state: TaskStateType}>){
      state.currentlyOpenedTask.status = action.payload.state
     }
  }
})

export const workItemsReducer = slice.reducer
export const {setWorkItemData,setCurrentlyOpenedTaskState,setTabList,setCurrentlyOpendTask,setCurrentlyOpendTaskSystemInfo, setWorkItems,setUpdatedWorkItems, setTab, setIsNewTask, setNewTaskID, setCurrentAttachment, downloadAttachment} = slice.actions



// export async function ConvertImgUrls(token: string, txt:string, projectId: number, dispatch: Dispatch) {
//     let parser = new DOMParser()
//     let html = parser.parseFromString(txt, 'text/html')
//     let arr = html.getElementsByTagName("img")
//     console.log('ARR: ', arr)
//     let urlsArr = []
//     for (let i = 0; i < arr.length; i++){
//       let str = arr[i].src.toString()
//       let elems = str.split('/')
//       let elems2 = elems[elems.length - 1].split('?')
//       let attachmentId = elems2[0]

//       let x = elems2[1].split('=')
//       let fileNameFromString = x[1]
//       console.log('fileNameFromString: ', fileNameFromString)
//       let fileName: string
//       if(arr[i].alt === 'attached picture') {
//         fileName = fileNameFromString
//       }
//       else {
//         fileName = arr[i].alt
//       }
//       const res = await projectsAPINEW.getAttachment(token, projectId, attachmentId, fileName)
//       const url = window.URL.createObjectURL(res.data)
//       arr[i].src = url
//       urlsArr.push(url)
//     }
//     return new XMLSerializer().serializeToString(html)
// }